import React, { useEffect, useState } from "react";
import api, { formatINR } from "../../lib/api";
import { Card } from "../../components/ui/card";

export default function AdminDashboard() {
  const [stats, setStats] = useState(null);
  useEffect(() => { api.get("/admin/dashboard").then((r) => setStats(r.data)); }, []);
  if (!stats) return <div>Loading...</div>;
  const cards = [
    { label: "Total Orders", value: stats.total_orders },
    { label: "Pending", value: stats.pending },
    { label: "Confirmed", value: stats.confirmed },
    { label: "Completed", value: stats.completed },
    { label: "Active Packages", value: stats.total_packages },
    { label: "Categories", value: stats.total_categories },
    { label: "Revenue", value: formatINR(stats.revenue) },
  ];
  return (
    <div data-testid="dashboard-page">
      <h1 className="font-serif-display text-4xl mb-8">Dashboard</h1>
      <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mb-10">
        {cards.map((c) => (
          <div key={c.label} className="bg-background rounded-2xl p-5 border border-border" data-testid={`stat-${c.label.toLowerCase().replace(/\s/g, "-")}`}>
            <div className="text-xs uppercase tracking-widest text-muted-foreground mb-2">{c.label}</div>
            <div className="font-serif-display text-3xl">{c.value}</div>
          </div>
        ))}
      </div>
      <h2 className="font-serif-display text-2xl mb-4">Recent Orders</h2>
      <div className="bg-background rounded-2xl border border-border overflow-hidden">
        <table className="w-full text-sm">
          <thead className="bg-muted text-left text-xs uppercase tracking-widest">
            <tr><th className="p-3">Customer</th><th className="p-3">Package</th><th className="p-3">Total</th><th className="p-3">Status</th><th className="p-3">Date</th></tr>
          </thead>
          <tbody>
            {stats.recent_orders.map((o) => (
              <tr key={o.id} className="border-t border-border">
                <td className="p-3">{o.name}</td>
                <td className="p-3">{o.package_title}</td>
                <td className="p-3">{formatINR(o.total)}</td>
                <td className="p-3"><span className="px-2 py-1 rounded-full text-xs bg-primary/10 text-primary">{o.status}</span></td>
                <td className="p-3 text-muted-foreground">{new Date(o.created_at).toLocaleDateString()}</td>
              </tr>
            ))}
            {stats.recent_orders.length === 0 && <tr><td colSpan={5} className="p-6 text-center text-muted-foreground">No orders yet.</td></tr>}
          </tbody>
        </table>
      </div>
    </div>
  );
}
